<script setup lang="ts">
import BadgeCheckbox from '../shared/BadgeCheckbox.vue'
import ElementalBadage from './ElementalBadage.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import HorizontalScroll from '@/components/HorizontalScroll/index.vue'
import HorizontalScrollItem from '@/components/HorizontalScroll/Item.vue'

const { state, toggleFilter, activeAll } = useElementalListsStore()

const listOption = computed(() => {
  return state.viewsActives?.[ElementalTypeEnum.List] ?? null
})

const isAllActive = computed(() => state.isAllActive)
</script>

<template>
  <HorizontalScroll
    v-if="state.viewsActives"
    as="ul"
    container-class="flex gap-1 px-3 w-full mt-1 items-center flex-shrink-0 h-8 !space-x-0"
  >
    <HorizontalScrollItem as="li">
      <BadgeCheckbox
        v-if="state.query === ''"
        class="flex-nowrap flex-shrink-0"
        :is-all="true"
        :model-value="isAllActive"
        :is-all-selected="isAllActive"
        @update:model-value="activeAll"
      >
        All
      </BadgeCheckbox>
    </HorizontalScrollItem>
    <template v-for="item in state.viewsActives">
      <HorizontalScrollItem v-if="item && item.elementaltype !== ElementalTypeEnum.List" :key="item?.elementaltype" as="li">
        <ElementalBadage
          :type="item.elementaltype"
          class="flex-nowrap flex-shrink-0"
          :is-all-active="isAllActive"
        />
      </HorizontalScrollItem>
    </template>
    <HorizontalScrollItem v-if="listOption" as="li">
      <BadgeCheckbox
        v-if="state.query === '' || (listOption.count > 0) "
        class="flex-nowrap flex-shrink-0"
        :is-all-selected="isAllActive"
        :model-value="listOption.filterActive"
        @update:model-value="toggleFilter(listOption.elementaltype)"
      >
        <template #default="{ isChecked }">
          <span>
            {{ listOption.label }}
          </span>
          <BubbleCount
            v-if="state.query !== '' && listOption.count > 0"
            :is-active="isChecked"
          >
            {{ listOption.count }}
          </BubbleCount>
        </template>
      </BadgeCheckbox>
    </HorizontalScrollItem>
  </HorizontalScroll>
</template>
